// Dependencies
import axios from 'axios';

export const CookieConsent = {
  root: null,
  button: null, 

  init() {
    // Get root
    this.root = document.getElementById('CookieBox');
    this.button = document.getElementById('ConsentCookies');

    // Cancel if any of the elements is missing
    if (!this.root || !this.button) {
      return;
    }

    // Show box
    this.root.classList.add('Cookie--show');

    // Click
    this.button.addEventListener('click', () => {
      if(!this.root.classList.contains('Cookie--loading')) {
        this.root.classList.add('Cookie--loading');
        this.acceptCookies();
      }
    });
  },

  acceptCookies() {
    // Accept cookies
    axios.post(
      THEME.restURL + 'bakoba/v1/accept-cookies', {}, {header: {'X-WP-Nonce': THEME.nonce}}
    ).then( res => {
      // console.log('Cookies accepted in backend ', res);
      setTimeout( () => { 
        this.root.classList.remove('Cookie--loading'); 
        this.root.classList.add('Cookie--accepted'); 
      }, 300);
    }).catch( error => {
      // console.log('Error: ', error);
      this.root.classList.remove('Cookie--loading');
    });
  },
  

};